import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export function formatBytes(bytes) {
  if (bytes < 1000) return `${bytes} B`;
  if (bytes < 1_000_000) return `${(bytes / 1000).toFixed(1)} KB`;
  if (bytes < 1_000_000_000) return `${(bytes / 1_000_000).toFixed(1)} MB`;
  return `${(bytes / 1_000_000_000).toFixed(2)} GB`;
}

function StorageUsageBar({ usage, compact = false }) {
  if (!usage) return null;
  const limit = usage.limitBytes || 1;
  const completed = usage.completedBytes / limit * 100;
  const pending = usage.pendingBytes / limit * 100;
  const reserved = usage.reservedBytes / limit * 100;
  const free = usage.isUnlimited ? 0 : Math.max(0, 100 - completed - pending - reserved);
  const details = usage.isUnlimited
    ? `Completed ${formatBytes(usage.completedBytes)} · Pending ${formatBytes(usage.pendingBytes)} · Unlimited`
    : `${formatBytes(usage.usedBytes)} used of ${formatBytes(usage.limitBytes)} · ${formatBytes(usage.availableBytes || 0)} free`;

  return <Tooltip title={details} arrow>
    <Box sx={{ minWidth: compact ? 180 : 260, cursor: 'help' }}>
      {!compact && <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}><Typography variant="body2" fontWeight="bold">Storage</Typography><Typography variant="body2" color="text.secondary">{usage.isUnlimited ? 'Unlimited' : `${formatBytes(usage.usedBytes)} / ${formatBytes(usage.limitBytes)}`}</Typography></Box>}
      <Box sx={{ display: 'flex', height: compact ? 8 : 14, borderRadius: 2, overflow: 'hidden', backgroundColor: '#e5e5e5' }}>
        {completed > 0 && <Box sx={{ width: `${completed}%`, backgroundColor: '#66a061' }} />}
        {pending > 0 && <Box sx={{ width: `${pending}%`, backgroundColor: '#d99a3d' }} />}
        {reserved > 0 && <Box sx={{ width: `${reserved}%`, backgroundColor: '#b9b9b9' }} />}
        {!usage.isUnlimited && free > 0 && <Box sx={{ width: `${free}%`, backgroundColor: '#eeeeee' }} />}
      </Box>
      {!compact && <Typography variant="caption" color="text.secondary">Green completed · Amber indexing/uploading</Typography>}
    </Box>
  </Tooltip>;
}

export default StorageUsageBar;
